{
  "OPTIONAL": "Optioneel",
  "BOOLEAN": {
    "YES": "Ja",
    "NO": "Nee"
  },
  "URGENCY": {
    "HIGH": "Hoog",
    "LOW": "Laag"
  },
  "APP": {
    "VERSION": "Deze app draait op versie {version}"
  },
  "BUTTONS": {
    "NEXT": "Volgende",
    "SKIP": "Overslaan",
    "CONFIRM": "Bevestig",
    "CLOSE": "Sluiten",
    "CANCEL": "Annuleren",
    "SHOW_ALL": "Toon alles",
    "HIDE": "Verbergen"
  },
  "FOOTER": {
    "HOME": "Home",
    "WORK": "Werk",
    "TOOLBOXES": "Toolboxes",
    "PROFILE": "Profiel"
  },
  "WORK": {
    "EMPTY_STATE_TITLE": "Nog geen projecten",
    "EMPTY_STATE_MESSAGE": "Projecten verschijnen hier snel."
  },
  "HOME": {
    "PRODUCT_NAME": "i-LOP",
    "PRODUCT_NAME_BETA": "BETA",
    "CHECK_IN_STATUS": {
      "CHECKED_IN": "Ingecheckt",
      "CHECKED_OUT": "Uitgecheckt",
      "CHECK_IN": "Inchecken",
      "CHECK_OUT": "Uitchecken"
    },
    "TO_FULFILL": "Te vervullen",
    "CHECKLISTS": "Checklists",
    "CERTIFICATES": "Certificaten",
    "SAFETY_INSTRUCTIONS": "Veiligheidsinstructies",
    "TOOLBOXES": "Toolboxes",
    "NOT_ASSIGNED_TO_PROJECT": {
      "TITLE": "Geen actief project",
      "MESSAGE": "Je hebt nog niet eerder op een project gewerkt, Vind een project om aan de slag te gaan!",
      "BUTTON": "Vind project"
    },
    "ALERTS": "Berichten",
    "NO_ALERTS": "Er zijn momenteel geen berichten",
    "CURRENT_CHECK_IN": "Momenteel ingecheckt",
    "LAST_PROJECT": "Laatste project",
    "CHECKED_IN_AT": "Ingecheckt om {time}",
    "LAST_CHECKED_IN": "Laatst ingecheckt om {time}",
    "CHECKED_OUT_AT": "Uitgecheckt om {time}",
    "FOREMAN": {
      "WORKERS_ON_SITE": "Werknemers op het werk",
      "START_WORK_INSTRUCTION": "Start Werk Instructie",
      "CREATE": "+ Aanmaken"
    }
  },
  "SAFETY_INSTRUCTIONS": {
    "TITLE": "Veiligheidsinstructies",
    "ALL_COMPLETED": "Alle vereiste veiligheidsinstructies zijn afgerond"
  },
  "SAFETY_INSTRUCTION": {
    "PREVIOUS": "Vorige",
    "NEXT": "Volgende",
    "FINISH": "Voltooien",
    "QUESTION_HINT_AT_LEAST_ONE": "Selecteer ten minste één juist antwoord",
    "QUESTION_HINT_ALL_CORRECT": "Selecteer alle juiste antwoorden",
    "QUESTION_ERROR_ALL_CORRECT": "Dit zijn niet de juiste antwoorden, probeer het opnieuw",
    "QUESTION_CORRECT": "Goed gedaan!",
    "QUESTION_ERROR_UNANSWERED": "Geef voor alle vragen het juiste antwoord voordat je doorgaat"
  },
  "LOGIN": {
    "EMAIL_LABEL": "E-mail",
    "PASSWORD_LABEL": "Wachtwoord",
    "EMAIL_PLACEHOLDER": "Voer je e-mailadres in",
    "PASSWORD_PLACEHOLDER": "Voer je wachtwoord in",
    "LOGIN_BUTTON": "Inloggen",
    "LOG_IN": "Inloggen",
    "FORGOT_PASSWORD": "Wachtwoord vergeten?",
    "LOGIN_WITH_YIVI": "Verder met Yivi",
    "YIVI_HELP": "Gebruik Yivi om in te loggen of een account aan te maken.",
    "PASSWORD_LOGIN": "Inloggen met wachtwoord"
  },
  "FORGOT_PASSWORD": {
    "TITLE": "Wachtwoord vergeten",
    "DESCRIPTION": "Voer je e-mailadres in zodat we je een e-mail kunnen sturen om je wachtwoord te herstellen",
    "EMAIL_LABEL": "E-mailadres",
    "EMAIL_PLACEHOLDER": "Voer je e-mailadres in",
    "SUCCESS_MESSAGE_1": "We hebben een bevestigingsmail gestuurd naar",
    "SUCCESS_MESSAGE_2": "Controleer je e-mail en klik op de bevestigingslink om verder te gaan",
    "SUBMIT_BUTTON": "Verzenden",
    "RESEND_BUTTON": "E-mail opnieuw verzenden"
  },
  "RESET_PASSWORD": {
    "TITLE": "Wachtwoord resetten",
    "DESCRIPTION": "Maak een nieuw, sterk wachtwoord dat je niet voor andere websites gebruikt",
    "PASSWORD_LABEL": "Nieuw wachtwoord",
    "PASSWORD_PLACEHOLDER": "Voer je nieuwe wachtwoord in",
    "VERIFY_PASSWORD_LABEL": "Nieuw wachtwoord verifiëren",
    "VERIFY_PASSWORD_PLACEHOLDER": "Voer je nieuwe wachtwoord nogmaals in",
    "PASSWORD_MISMATCH": "Wachtwoorden komen niet overeen",
    "RESET_BUTTON": "Wachtwoord resetten",
    "INVALID_TOKEN": "Het e-mailadres is ongeldig of de token is verlopen. Vraag een nieuwe wachtwoordreset aan",
    "SUCCESS_TITLE": "Succes!",
    "SUCCESS_MESSAGE": "Je wachtwoord is succesvol gereset. Je kunt nu inloggen met je nieuwe wachtwoord.",
    "LOGIN": "Inloggen",
    "INVALID_LINK_TITLE": "Ongeldige resetlink",
    "INVALID_LINK_MESSAGE": "Deze wachtwoordresetlink is ongeldig of verlopen. Vraag een nieuwe wachtwoordreset aan.",
    "REQUEST_NEW_LINK": "Vraag een nieuwe resetlink aan"
  },
  "ACCEPT_INVITATION": {
    "INTRO": {
      "TITLE": "Uitnodiging",
      "DESCRIPTION": "Je bent uitgenodigd voor een dienstverband. Controleer de gegevens en accepteer om aan de slag te gaan.",
      "SUBSCRIPT": "Deze uitnodigingslink is eenmalig te gebruiken en verloopt over 7 dagen.",
      "BUTTON": "Uitnodiging accepteren"
    },
    "OFFER": {
      "ORGANISATION": "Organisatie",
      "FUNCTION": "Functie",
      "START_DATE": "Startdatum",
      "END_DATE": "Einddatum",
      "INVITED_AS": "Uitgenodigd als"
    },
    "ACCEPT_ON_PHONE": {
      "TITLE": "Accepteren op je telefoon",
      "DESCRIPTION": "Scan deze code met de camera van je telefoon om deze uitnodiging in de i-LOP app te openen."
    },
    "SIGN_IN_TO_ACCEPT": "Log in om te accepteren",
    "SUCCESS": {
      "TITLE": "Uitnodiging geaccepteerd!",
      "DESCRIPTION": "Je dienstverband is nu gekoppeld aan je account.",
      "BUTTON": "Doorgaan"
    },
    "ALREADY_ACCEPTED": {
      "TITLE": "Al geaccepteerd",
      "DESCRIPTION": "Deze uitnodiging is al geaccepteerd."
    },
    "NOT_INVITABLE": {
      "TITLE": "Uitnodiging niet langer geldig",
      "DESCRIPTION": "Dit dienstverband is niet langer beschikbaar. Neem contact op met je werkgever."
    },
    "EXPIRED": {
      "TITLE": "Uitnodiging verlopen",
      "DESCRIPTION": "Deze uitnodigingslink is verlopen. Vraag je werkgever om een nieuwe uitnodiging te sturen."
    },
    "INVALID_LINK": {
      "TITLE": "Ongeldige uitnodigingslink",
      "DESCRIPTION": "Deze uitnodigingslink is ongeldig. Neem contact op met je beheerder om een nieuwe uitnodiging aan te vragen."
    }
  },
  "ERRORS": {
    "AUTHENTICATION": {
      "USER_ALREADY_EXISTS": "E-mailadres al in gebruik",
      "INVALID": "Je e-mailadres of wachtwoord klopt niet",
      "TRY_LATER": "Je kunt op dit moment niet inloggen, probeer het later opnieuw",
      "TOKEN_NOT_VALID": "Je moet opnieuw inloggen",
      "YIVI_FAILED": "Inloggen met Yivi kon niet worden afgerond"
    },
    "PROJECT_SELECT": {
      "ALREADY_ASSIGNED": "Je bent al toegewezen aan dit project.",
      "NOT_ASSIGNED": "Je bent niet toegewezen aan dit project."
    },
    "QRCODE_SCANNER": {
      "NO_PERMISSION": "Geen toestemming om de camera te gebruiken",
      "INVALID": "De QR-code is ongeldig",
      "EXPIRED": "De QR-code is verlopen",
      "NO_PROJECT_SELECTED": "Kies eerst het project waarvoor je wilt verifiëren",
      "NO_PROJECT_TO_VERIFY": "Je voert hier geen enkel project uit, dus er is geen project om deze medewerker voor te verifiëren",
      "PROJECTS_UNAVAILABLE": "Je projecten konden niet worden geladen. Controleer je verbinding en scan opnieuw",
      "IDENTITY_NOT_RESOLVED": "De QR-code hoort niet bij één app-account"
    },
    "AVATAR": {
      "TOO_LARGE": "Het fotobestand is te groot. Kies een kleinere foto.",
      "DIMENSIONS_TOO_LARGE": "De foto is te groot. Kies een kleinere foto.",
      "UNSUPPORTED_IMAGE_TYPE": "Dit bestandstype kan niet als profielfoto worden gebruikt. Kies een JPEG-, PNG- of WebP-afbeelding.",
      "MALFORMED_IMAGE": "De foto kon niet worden gelezen. Probeer een andere foto.",
      "INVALID_IMAGE": "De foto kan niet als profielfoto worden gebruikt."
    },
    "GENERIC": "Er is iets misgegaan",
    "NETWORK": "Kan geen verbinding maken met de server",
    "NOT_FOUND": "Kan iets niet vinden",
    "UNKNOWN": "Er heeft een onbekende fout plaatsgevonden",
    "OFFLINE": "Je bent niet online",
    "NOT_CHECKED_IN": "Je bent niet ingecheckt op een project",
    "CONTENT_OUTSTANDING": "Rond eerst alle instructies en toolboxen af voordat je tekent.",
    "INVALID_SIGNATURE": "Deze handtekening kon niet worden gelezen. Teken opnieuw.",
    "NO_PROJECT_ACCESS": "Je hebt geen toegang tot dit project",
    "NO_ACCESS": "Je hebt hiervoor geen rechten",
    "INVITATION_INVALID": "De uitnodigingslink is niet geldig.",
    "INVITATION_EXPIRED": "De uitnodigingslink is verlopen. Vraag je werkgever om een nieuwe.",
    "EMPLOYMENT_ALREADY_ACCEPTED": "Dit dienstverband is al gekoppeld aan een ander account.",
    "EMPLOYMENT_NOT_INVITABLE": "Dit dienstverband kan niet meer worden geaccepteerd.",
    "PERSON_BINDING_CONFLICT": "Dit persoonsrecord is gekoppeld aan een ander app-account. Neem contact op met je beheerder.",
    "GATE_ENTRY_REQUIRES_EXCEPTION": "Deze medewerker mist vereisten, dus toelaten moet als uitzondering worden geregistreerd.",
    "PERSON_NOT_BOUND": "Deze persoon heeft nog geen app-account.",
    "PERSON_NO_PROJECT_ACCESS": "De gescande persoon heeft geen toegang tot dit project",
    "PERSON_ALREADY_CHECKED_IN": "De gescande persoon is al ingecheckt op dit project",
    "SUBJECT_NOT_FOUND": "Het account van de gescande persoon is niet gevonden",
    "SUBJECT_NOT_CHECKED_IN": "Deze medewerker is niet ingecheckt op dit project, dus je kunt diegene hier niet toelaten"
  },
  "QRCODE_SCANNER": {
    "TITLE": "Bezig met scannen",
    "SCAN_QR_CODE": "QR-code scannen",
    "RETRY_SCAN_QR_CODE": "Opnieuw QR-code scannen",
    "CAMERA_PERMISSION_DENIED_EXPLANATION": "Open de instellingen en geef toestemming om de camera te gebruiken",
    "OPEN_SETTINGS": "Open instellingen",
    "SCAN_AGAIN": "Volgende scannen",
    "VERIFY_AGAINST": "Verifiëren voor project",
    "VERIFY_AGAINST_PLACEHOLDER": "Kies een project"
  },
  "SELECT": {
    "DEFAULT_TITLE": "Kies een optie",
    "DEFAULT_MULTISELECT_TITLE": "Kies één of meerdere opties"
  },
  "ONBOARDING": {
    "LOG_IN": "Inloggen",
    "WELCOME_MESSAGE": "Welkom bij het leer- en ontwikkelplatform."
  },
  "YIVI_REGISTRATION": {
    "TITLE": "Rond je account af",
    "DESCRIPTION": "We hebben je identiteitsgegevens van Yivi ontvangen. Vul de resterende iLOP-gegevens aan om verder te gaan.",
    "BIRTH_DATE": "Geboortedatum",
    "GENDER": "Geslacht",
    "SUBMIT": "Account aanmaken",
    "CANCEL": "Annuleren"
  },
  "GENDER": {
    "MALE": "Man",
    "FEMALE": "Vrouw",
    "OTHER": "Anders"
  },
  "SAVED_WORK": {
    "BUTTON_TITLE": "Opgeslagen"
  },
  "NOTIFICATION": {
    "DISMISS": "Sluiten"
  },
  "PROFILE": {
    "PERSONAL_INFORMATION": "Persoonlijke informatie",
    "NAME": "Voornaam",
    "SURNAME": "Achternaam",
    "NICKNAME": "Roepnaam",
    "NICKNAME_PLACEHOLDER": "Vul je roepnaam in (optioneel)",
    "CERTIFICATES": "Certificaten",
    "SAVE": "Opslaan",
    "SELECT_FUNCTION": "Functie selecteren",
    "LOGOUT": "Uitloggen",
    "TOAST": {
      "SAVED": "Persoonlijke informatie is opgeslagen",
      "ERROR": "Er is een fout opgetreden bij het opslaan van de persoonlijke informatie"
    },
    "AVATAR": {
      "ACTION_SHEET_TITLE": "Wat wil je doen?",
      "CHANGE_LABEL": "Profiel foto wijzigen",
      "DELETE_LABEL": "Profiel foto verwijderen",
      "CANCEL_LABEL": "Annuleren",
      "RESIZE_ERROR": "De foto kon niet worden verwerkt. Probeer een andere foto.",
      "CROP_TITLE": "Foto bijsnijden",
      "CROP_CONFIRM": "Foto gebruiken",
      "CROP_ZOOM_LABEL": "Zoomen"
    },
    "SETTINGS": "Instellingen",
    "SETTINGS_ROUTES": {
      "CHANGE_PASSWORD": "Wachtwoord wijzigen"
    },
    "PASSWORD": {
      "LABEL_CURRENT": "Huidig wachtwoord",
      "PLACEHOLDER_CURRENT": "Voer je huidige wachtwoord in",
      "LABEL_NEW": "Nieuw wachtwoord",
      "PLACEHOLDER_NEW": "Voer je nieuwe wachtwoord in",
      "LABEL_VERIFY_NEW": "Nieuw wachtwoord verifiëren",
      "PLACEHOLDER_VERIFY_NEW": "Voer je nieuwe wachtwoord nogmaals in",
      "BUTTON_LABEL": "Wachtwoord wijzigen",
      "TOAST": {
        "SUCCESS": "Wachtwoord is gewijzigd. Log opnieuw in met je nieuwe wachtwoord",
        "ERROR": "Er is een fout opgetreden bij het wijzigen van het wachtwoord"
      },
      "FORM_VALIDATION_MISMATCH": "De nieuwe wachtwoorden komen niet overeen"
    }
  },
  "PROJECT_DETAILS": {
    "TITLE": "Projectdetails",
    "SWI_SIGNED": "SWI getekend",
    "SWI_OPEN": "SWI open",
    "SWI_SIGNED_COUNT": "{count} SWI getekend",
    "SWI_SIGNED_OF": "{signed} van {total} SWI getekend",
    "REPORT_SAFETY_RISKS": "Veiligheidsrisico melden",
    "SEE_SAFETY_REPORTS": "Open veiligheidsmeldingen",
    "CONTRACTOR": "Opdrachtnemer",
    "CLIENT": "Opdrachtgever",
    "SELECT": "Selecteer",
    "WORKERS": "Werknemers",
    "DESELECT": "Deselecteer",
    "WORKERS_EMPTY_STATE": "Er zijn nog geen werknemers aangemeld op dit project.",
    "UNKNOWN_EMPLOYER": "Werkgever onbekend",
    "CERTIFICATES": "Benodigde project certificaten",
    "TOOLBOXES": "Benodigde project toolboxen",
    "TOOLBOXES_ALL_COMPLETED": "Alle benodigde toolboxen zijn afgerond",
    "ALERTS": "Berichten",
    "CREATE_ALERT": "Bericht toevoegen",
    "ALERTS_EMPTY_STATE": "Er zijn momenteel geen berichten voor dit project",
    "MAIN_OFFICE": "Hoofdkantoor",
    "CHECK_IN": "Inchecken",
    "CHECK_OUT": "Uitchecken",
    "AT_WORK": "{count} op het werk",
    "REQUIREMENTS_CHECKLIST": "Projectvereisten",
    "OVERWRITE_CHECKIN_TITLE": "Inchecken",
    "OVERWRITE_CHECKIN_MESSAGE": "Je bent momenteel ingecheckt bij \"{projectName}\". Als je hier incheckt, wordt die check-in beëindigd.",
    "OVERWRITE_CHECKIN_CONFIRM": "Inchecken",
    "OVERWRITE_CHECKIN_CANCEL": "Annuleren"
  },
  "PROJECT_SELECT": {
    "TITLE": "Selecteer project",
    "PROJECT_NAME": "Project naam",
    "PROJECT_FUNCTION": "Functie in project",
    "SELECT_AT_LEAST_ONE_FUNCTION": "Selecteer minstens één functie.",
    "EMPLOYEE": "Werknemer",
    "NEXT": "Volgende",
    "ALREADY_CHECKED_IN_TITLE": "Al ingecheckt",
    "ALREADY_CHECKED_IN_MESSAGE": "Je bent al ingecheckt op dit project. Je hoeft niets te doen.",
    "INVALID_CODE": "Deze projectcode is niet meer geldig. Vraag de uitvoerder om de huidige code.",
    "REPORT_TO_FOREMAN_TITLE": "Meld je bij de uitvoerder",
    "REPORT_TO_FOREMAN_MESSAGE": "Je bent ingecheckt, maar je staat niet op dit project. Meld je direct bij de uitvoerder."
  },
  "PROJECT_SELECT_CONFIRM": {
    "ALL_FULFILLED": "Aan alle vereisten is voldaan",
    "BUTTON": "Bevestig",
    "TITLE": "Bevestig selecteren project"
  },
  "PROJECT_SELECT_SUCCESS": {
    "SUCCESS": "Gelukt!",
    "SELECTED": "Je hebt je aangemeld voor het project.",
    "DESELECTED": "Je hebt je afgemeld voor het project.",
    "BUTTON": "Home"
  },
  "CERTIFICATE": {
    "EXPIRED": "Verlopen op {date}",
    "VALID_UNTIL": "Geldig tot {date}",
    "EXPIRES_IN": "Verloopt binnen {duration}",
    "EXPIRES_SOON": "Verloopt binnen 3 maand",
    "EXPIRES_NEVER": "Verloopt nooit",
    "MISSING": "Nog niet behaald",
    "PENDING": "In afwachting van beoordeling",
    "REJECTED": "Afgewezen",
    "VIEW_DOCUMENT": "Document",
    "VIEW_DOCUMENT_N": "Document {n}",
    "REGISTERED_TO": "Geregistreerd op naam van {name}"
  },
  "DOCUMENT_INPUT": {
    "ADD": "Foto of PDF toevoegen",
    "TAKE_PHOTO": "Foto nemen",
    "CHOOSE_FROM_LIBRARY": "Kies uit bibliotheek",
    "CHOOSE_PDF": "Kies PDF",
    "REMOVE": "Verwijderen",
    "CANCEL": "Annuleren"
  },
  "ADD_CERTIFICATE": {
    "TITLE": "Certificaat toevoegen",
    "CERTIFICATE": "Certificaat",
    "CERTIFICATE_NUMBER": "Certificaatnummer",
    "ISSUED_ON": "Uitgegeven op",
    "EXPIRES_ON": "Verloopt op",
    "DOCUMENT": "Document",
    "MISSING_FIELDS": "Selecteer een organisatie en certificaat.",
    "ERROR": "Er is iets misgegaan. Probeer het opnieuw.",
    "CHOOSER": {
      "IMPORT": "Importeren uit register",
      "UPLOAD": "Document uploaden"
    }
  },
  "IMPORT_CERTIFICATE": {
    "TITLE": "Certificaat importeren",
    "LAST_NAME": "Achternaam",
    "DATE_OF_BIRTH": "Geboortedatum",
    "REGISTRY": "Register",
    "CERTIFICATE_NUMBER": "Certificaatnummer",
    "MISSING_FIELDS": "Vul alle velden in.",
    "SUCCESS": "Certificaat geïmporteerd.",
    "STATUS": {
      "NOTFOUND": "Geen certificaat gevonden voor deze gegevens.",
      "REGISTRYERROR": "Het register kon niet worden bereikt. Probeer het later opnieuw."
    }
  },
  "CERTIFICATES": {
    "NO_CERTIFICATES": "Geen certificaten gevonden",
    "EXPIRED_CERTIFICATES": "Sommige van je certificaten zijn verlopen. Vernieuw ze om aan de slag te blijven."
  },
  "MARKDOWN_CONTENT": {
    "TERMS_AND_CONDITIONS": "Algemene voorwaarden",
    "PRIVACY_POLICY": "Privacybeleid",
    "APP_INFO": "App informatie",
    "AVG_STATEMENT": "AVG verklaring"
  },
  "HUMANIZE_DURATION": {
    "MONTHS": "{count, plural, =1{maand} other{maanden}}",
    "DAYS": "{count, plural, =1{dag} other{dagen}}",
    "SOON": "binnenkort"
  },
  "PERSON": {
    "FIRST_NAME": "Voornaam",
    "LAST_NAME": "Achternaam",
    "EMAIL": "E-mailadres",
    "FUNCTION": "Functie"
  },
  "WORKER_PROFILE": {
    "FUNCTION": "Functie",
    "PROJECT": "Huidig project",
    "CERTIFICATES": "Certificaten",
    "PROJECT_DETAILS": "Projectdetails",
    "UPDATE_PERSON_ACTION": "Gegevens wijzigen",
    "ASSIGN_TO_PROJECT_ACTION": "Aan mijn project toewijzen"
  },
  "PHOTOS": {
    "PROFILE_PHOTO": "Kies een profiel foto",
    "CANCEL": "Annuleren",
    "TAKE_PHOTO": "Maak een foto",
    "CHOOSE_FROM_LIBRARY": "Kies uit bibliotheek"
  },
  "UMA": {
    "MY_REPORTS": {
      "TITLE": "Mijn meldingen",
      "EMPTY_STATE_TITLE": "Geen meldingen",
      "EMPTY_STATE_MESSAGE": "Veiligheidsrisico's die je zelf hebt gemeld, verschijnen hier.",
      "CREATE_REPORT": "Maak een melding"
    },
    "REPORT": {
      "ASSIGNED_TO": "In behandeling bij {name}",
      "REPORTED_BY": "Gemeld door {name}",
      "REPORTED_BY_ANONYMOUS": "Anoniem gemeld"
    },
    "PROJECT_REPORTS": {
      "TITLE": "Meldingen voor {projectName}",
      "EMPTY_STATE_TITLE": "Geen meldingen",
      "EMPTY_STATE_MESSAGE": "Veiligheidsrisico's die op dit project gemeld zijn, verschijnen hier."
    },
    "CANNOT_CREATE_REPORT": {
      "TITLE": "Melding maken niet mogelijk",
      "DESCRIPTION": "Je bent nog niet aangemeld op een project. Meld je aan om een melding te kunnen maken."
    },
    "NEW_REPORT": {
      "CREATE_NEW_REPORT": "Melding maken",
      "GENERAL": {
        "FORM_TITLE": "Algemeen",
        "CATEGORY": "Wat wil je melden?",
        "IS_SOLVED": "Is het opgelost?",
        "IS_URGENT": "Urgentie",
        "IS_ANONYMOUS": "Anoniem melden",
        "PROJECT": "Op welk project wil je deze melding maken?",
        "NO_PROJECTS": "Je bent nog niet aangemeld op een project. Meld je aan om een melding te kunnen maken.",
        "CHOOSE_PROJECT": "Kies een project",
        "CONFIRM_PROJECT": "Je bent niet aangemeld op dit project. Weet je zeker dat je deze melding wilt maken?",
        "CONFIRM_PROJECT_BUTTON": "Ja ik weet het zeker",
        "VICTIMS": "Slachtoffers?",
        "ABSENTEEISM": "Verzuim",
        "HOSPITALISED": "Ziekenhuisopname?",
        "HOSPITALISED_WARNING": {
          "BEFORE_PHONE": "WE ZIJN VERPLICHT DIT ONGEVAL VANWEGE DE ZIEKENHUISOPNAME TE MELDEN BIJ DE ARBEIDSINSPECTIE. DAT KAN OP",
          "BETWEEN_PHONE_AND_URL": "OF VIA HET ONLINE FORMULIER:",
          "AFTER_LINK": "Overleg met je leidinggevende, de voorman of V&G coördinator wie deze melding verzorgt."
        }
      },
      "SITUATION": {
        "FORM_TITLE": "Situatie",
        "PHOTOS": "Hoe ziet de situatie er uit?",
        "PHOTOS_PLACEHOLDER": "Voeg een of meerdere foto's toe, of vul een omschrijving in",
        "DESCRIPTION": "Omschrijf de situatie",
        "SAFE_SITUATION_DESCRIPTION": "Veilige situatie",
        "RISK": "Risico",
        "DESCRIPTION_OF_SITUATION": "Situatieomschrijving",
        "ACTIONS_TAKEN": "Acties ondernomen",
        "RISK_CATEGORY": {
          "LABEL": "Categorie risico",
          "PLACEHOLDER": "Kies een categorie",
          "REQUIRED": "Categorie is verplicht"
        }
      },
      "SUMMARY": {
        "TITLE": "Melding is ingestuurd",
        "MESSAGE": "Melding met nummer #{{id}} is ingestuurd."
      },
      "SEND": "Insturen",
      "SUCCESS_TOAST": "Veiligheidsmelding succesvol aangemaakt",
      "VALIDATION": {
        "MISSING_FIELDS": "Vul alle verplichte velden in"
      }
    },
    "REPORT_DETAILS": {
      "NOT_ASSIGNED_TO": "Niet toegewezen aan een medewerker",
      "ASSIGNED_TO_PERSON": "Toegewezen aan medewerker",
      "ASSIGN_TO_PERSON_PLACEHOLDER": "Toewijzen aan medewerker",
      "DETAILS": "Details",
      "TITLE": "Melding {reportId} bekijken",
      "PROJECT_NAME": "Project",
      "REPORTER": "Melder",
      "ANONYMOUS_REPORTER": "Anonieme melder",
      "UNKNOWN_AUTHOR": "Onbekende auteur",
      "CATEGORY": "Soort melding",
      "URGENCY": "Urgentie",
      "SOLVED": "Opgelost",
      "PHOTOS": "Foto's",
      "PHOTOS_EMPTY": "Deze melding bevat geen foto's",
      "DESCRIPTION": "Omschrijving",
      "RISK": "Risico",
      "CREATED_AT": "Aangemaakt op",
      "CREATE_COMMENT": "Opmerking plaatsen",
      "COMMENTS": "Opmerkingen",
      "COMMENTS_EMPTY": "Er zijn nog geen opmerkingen geplaatst",
      "COMMENT_BY": "Opmerking van {person}",
      "COMMENT_CREATED": "Opmerking succesvol geplaatst",
      "LOGS": "Logs",
      "LOGS_EMPTY": "Er zijn nog geen logs",
      "LOG": {
        "CREATED": "Melding aangemaakt door {actor}",
        "STATUS_CHANGED": "Status gewijzigd naar {newStatus} door {actor}",
        "COMMENTED": "Opmerking geplaatst door {actor}"
      },
      "NOT_IN_PROJECT": "Melder was niet aangemeld op dit project"
    }
  },
  "PUSH_NOTIFICATIONS": {
    "CLOSE": "Sluiten",
    "OPEN": "Openen"
  },
  "REPORT_CATEGORY": {
    "ACCIDENT": "Ongeval",
    "UNSAFE_SITUATION": "Onveilig",
    "SAFE_SITUATION": "Veilig"
  },
  "REPORT_STATUS": {
    "NEW": "Ongelezen",
    "IN_PROGRESS": "In behandeling",
    "SOLVED": "Opgelost",
    "ON_HOLD": "Gepauzeerd"
  },
  "NOTIFICATIONS": {
    "TITLE": "Notificaties",
    "EMPTY_STATE_TITLE": "Geen notificaties",
    "EMPTY_STATE_MESSAGE": "Hier vind je alle belangrijke notificaties uit het heden en verleden",
    "NOTIFICATION_SENT_AT_FORMAT": "d MMMM HH:mm",
    "MARK_AS_READ": "Markeer als gelezen",
    "MARK_ALL_AS_READ": "Alles markeren als gelezen",
    "MARK_ALL_AS_READ_SUCCESS": "Alle notificaties zijn gemarkeerd als gelezen",
    "DELETE": "Verwijderen",
    "DELETE_SUCCESS": "Notificatie verwijderd"
  },
  "REPORT_TRANSITION": {
    "NEW": "Terug naar nieuw",
    "IN_PROGRESS": "In behandeling nemen",
    "SOLVED": "Markeren als opgelost",
    "ON_HOLD": "Pauzeren",
    "SOLVED_CONFIRMATION_TITLE": "Markeer melding als opgelost?",
    "SOLVED_CONFIRMATION_MESSAGE": "Weet je zeker dat je deze melding als opgelost wilt markeren?"
  },
  "SPEECH_RECOGNITION": {
    "TITLE": "Spreek je tekst in",
    "BTN_LABEL": "Tekst inspreken",
    "PERMISSION_ERROR": "Tekst inspreken niet mogelijk. Er is geen toestemming gegeven. Open de instellingen van je telefoon en geef toestemming om tekst in te spreken voor deze app.",
    "LISTENING": "Aan het luisteren...",
    "USE_RESULT": "Resultaat invoeren"
  },
  "CERTIFICATE_LIST": {
    "MY_EMPTY_STATE": "Je hebt nog geen certificaten behaald",
    "PERSON_EMPTY_STATE": "Deze werknemer heeft nog geen certificaten behaald",
    "PROJECT_EMPTY_STATE": "Er zijn geen relevante certificaten voor dit project",
    "PERSON_PROJECT_EMPTY_STATE": "Er zijn geen relevante certificaten voor deze werknemer op dit project"
  },
  "ALERT_CATEGORY": {
    "GENERAL": "Algemeen",
    "WEATHER": "Weer",
    "LOGISTIC": "Logistiek",
    "SAFETY": "Veiligheid"
  },
  "ALERT_DETAILS": {
    "EDIT": "Bewerken",
    "TITLE": "Bericht details",
    "CONFIRM": "Begrepen",
    "DELETE_TITLE": "Bericht verwijderen",
    "DELETE_MESSAGE": "Weet je zeker dat je dit bericht wilt verwijderen?",
    "DELETE_CONFIRM": "Verwijderen",
    "DELETE_SUCCESS": "Bericht verwijderd"
  },
  "ALERT_PLAYER": {
    "PLAY": "Afspelen",
    "PAUSE": "Pauzeren",
    "LANGUAGE": "Taal",
    "SEEK": "Voortgang",
    "FULLSCREEN": "Volledig scherm"
  },
  "ALERT": {
    "CATEGORY": "Categorie",
    "TITLE": "Titel",
    "DESCRIPTION": "Omschrijving",
    "VALID_FROM": "Vanaf",
    "VALID_UNTIL": "Tot",
    "FROM": "vanaf",
    "UNTIL": "tot",
    "VIDEO": "Video",
    "REMOVE_VIDEO": "Video verwijderen",
    "TYPE": "Type bericht",
    "TYPE_TEXT": "Tekst",
    "TYPE_VIDEO": "Video",
    "ADD_TARGET_AUDIENCE": "Doelgroep toevoegen",
    "TARGET_AUDIENCE": "Doelgroep",
    "TARGET_AUDIENCE_EVERYONE": "Iedereen",
    "TARGET_AUDIENCE_MANAGEMENT": "Leidinggevenden",
    "SELECT_TARGET_AUDIENCE": "Selecteer doelgroep",
    "NO_FILE_SELECTED": "Geen bestand geselecteerd",
    "CHOOSE_FILE": "Kies bestand",
    "TRANSLATION": "Vertaling",
    "TRANSLATION_DESCRIPTION": "Vertaal deze video",
    "VIDEO_UPLOAD_FAILED": "Video upload mislukt",
    "AUDIENCE": {
      "MANAGEMENT": "Leidinggevenden",
      "ORGANISATION": "Organisatie:",
      "FUNCTION": "Functie:",
      "FUNCTION_GROUP": "Functiegroep:",
      "ADD_MANAGEMENT": "Leidinggevenden",
      "ADD_ORGANISATION": "Organisatie",
      "ADD_FUNCTION": "Functie of groep",
      "SELECT_ORGANISATION": "Kies een organisatie",
      "NO_ORGANISATIONS": "Geen organisaties op dit project.",
      "LOADING_ORGANISATIONS": "Laden..."
    }
  },
  "NEW_ALERT": {
    "TITLE": "Bericht toevoegen",
    "ACTION": "Bericht aanmaken",
    "SUCCESS_TOAST_MESSAGE": "Bericht succesvol aangemaakt"
  },
  "EDIT_ALERT": {
    "TITLE": "Bericht bewerken",
    "ACTION": "Wijzigingen opslaan",
    "SUCCESS_TOAST_MESSAGE": "Bericht succesvol bijgewerkt"
  },
  "EDIT_PERSON_PROJECT": {
    "TITLE": "Project toewijzen",
    "SUCCESS_TOAST_MESSAGE": "Project toewijzing succesvol bijgewerkt"
  },
  "REASSIGN_PERSON_PROJECT": {
    "TITLE": "Project toewijzen",
    "SUCCESS_TOAST_MESSAGE": "Project toewijzing succesvol"
  },
  "SELECT_UI": {
    "SEARCHBAR_PLACEHOLDER": "Zoek een optie"
  },
  "CHECKLIST": {
    "COMPLETED": "Checklist succesvol afgerond",
    "ERROR": "Er is iets fout gegaan bij het afronden van de checklist",
    "LIST_LABEL": "Checklists",
    "ALL_COMPLETED": "Alle vereiste checklists zijn afgerond",
    "COMPLETE": "Afronden"
  },
  "PASSWORD_COMPLEXITY": {
    "REQUIREMENTS": "Wachtwoord vereisten",
    "MIN_LENGTH": "Minimaal {minLength} karakters",
    "UPPERCASE": "Minimaal één hoofdletter",
    "LOWERCASE": "Minimaal één kleine letter",
    "DIGIT": "Minimaal één cijfer",
    "SPECIAL_CHAR": "Minimaal één speciaal teken"
  },
  "FUNCTION_SELECT": {
    "ROOT": "Hoofd",
    "SEARCH_PLACEHOLDER": "Zoek een functie",
    "NO_RESULTS": "Geen functies gevonden",
    "WHOLE_CATEGORY": "Hele groep: {name}"
  },
  "WORKER_DETAIL": {
    "START_WORK_INSTRUCTION": "Start Werk Instructie",
    "SWI_SIGNED_ON": "Getekend op {moment}",
    "NO_SWI_SIGNATURE": "Nog niet getekend",
    "SWI_SIGNATURE_ALT": "Handtekening",
    "SWI_SIGNATURE_FAILED": "De handtekening kon niet worden geladen",
    "TITLE": "Werknemergegevens",
    "ITEM_STATUS": {
      "PRESENT": "Aanwezig",
      "MISSING": "Ontbreekt",
      "EXPIRED": "Verlopen",
      "EXPIRED_GRACE_PERIOD": "Verlopen (respijtperiode)"
    },
    "CERTIFICATES": "Certificaten",
    "CHECKLISTS": "Checklists",
    "SAFETY_INSTRUCTIONS": "Veiligheidsinstructies",
    "TOOLBOXES": "Toolboxen",
    "NAME": "Naam",
    "VERIFIED_AGAINST": "Gecontroleerd voor {project}",
    "BASIC_INFORMATION": "Basisinformatie",
    "ILOP_CONTENT": "i-LOP content",
    "NO_EMPLOYMENTS": "Deze werknemer heeft geen actieve dienstverbanden",
    "NO_ILOP_CONTENT": "Er is geen relevante i-LOP content voor deze werknemer op dit project",
    "CHECK_IN": {
      "SINCE": "Ingecheckt om"
    },
    "EMPLOYMENT": {
      "FUNCTION": "Functie",
      "FROM": "Vanaf",
      "TO": "Tot"
    },
    "CERTIFICATE": {
      "NUMBER": "Nummer",
      "ISSUED_ON": "Uitgegeven op",
      "ISSUED_FOR": "Uitgegeven aan",
      "EXPIRES_ON": "Verloopt op"
    },
    "CONTENT": {
      "COMPLETED_ON": "Afgerond op",
      "MEETING_ENDED": "Bijeenkomst geëindigd",
      "SIGNED": "Ondertekend"
    },
    "KVK": {
      "NUMBER": "KvK-nummer",
      "DOCUMENT_DATE": "Uittreksel van",
      "VALID_UNTIL": "Geldig tot",
      "DOCUMENT": "KvK-uittreksel"
    },
    "OPEN_DOCUMENT": "Openen",
    "OPEN_DOCUMENT_FAILED": "Het document kon niet worden geopend"
  },
  "GATE_ENTRY": {
    "TITLE": "Toegang registreren",
    "GAPS_HINT": "Deze medewerker mist vereisten, dus toelaten is een uitzondering.",
    "NOT_CHECKED_IN_HINT": "Deze medewerker is niet ingecheckt op dit project. Check ze in om ze toe te laten, of weiger de toegang.",
    "CHECK_IN_WORKER": "Medewerker inchecken",
    "DECISION": {
      "VALID": "Geldig",
      "EXCEPTION": "Uitzondering",
      "DENIED": "Geweigerd"
    },
    "REASON": {
      "HEADER_EXCEPTION": "Reden voor de uitzondering",
      "HEADER_DENIED": "Reden om toegang te weigeren",
      "MESSAGE": "Dit wordt vastgelegd met jouw naam en het tijdstip.",
      "PLACEHOLDER": "Beschrijf de reden",
      "CONFIRM": "Registreren"
    },
    "REGISTERED": "Toegang geregistreerd"
  },
  "EMPLOYMENT": {
    "TIMELINE": {
      "TITLE": "Dienstverbanden",
      "NO_EMPLOYMENTS": "Geen dienstverbanden beschikbaar.",
      "PRESENT": "Heden",
      "ACTIVE": "Actief",
      "NOT_YET_ACTIVE": "Nog niet actief",
      "LOAD_ERROR": "Er is een fout opgetreden bij het laden van de dienstverbanden.",
      "STATUS_FOR_ADMIN_REVIEW": "In beoordeling",
      "STATUS_FOR_USER_REVIEW": "Controleer uw dienstverband",
      "ADD_EMPLOYMENT": "Toevoegen",
      "REVIEW_NOTICE": "Er zijn dienstverbanden die wachten op uw beoordeling.",
      "REVIEW_NOTICE_ACTION": "Tik om ze te bekijken en te beoordelen.",
      "REVIEW_OPEN": "Beoordelen",
      "REVIEW_DETAILS_TITLE": "Dienstverband beoordelen",
      "FUNCTION": "Functie",
      "START_DATE": "Startdatum",
      "END_DATE": "Einddatum",
      "MANAGERIAL": "Leidinggevende functie",
      "YES": "Ja",
      "NO": "Nee",
      "ACCEPT": "Accepteren",
      "REJECT": "Afwijzen",
      "REVIEW_ACCEPT_SUCCESS": "Dienstverband succesvol geaccepteerd.",
      "REVIEW_REJECT_SUCCESS": "Dienstverband succesvol afgewezen.",
      "REVIEW_ERROR": "Er is een fout opgetreden bij het beoordelen van het dienstverband."
    },
    "DETAIL": {
      "TITLE": "Dienstverband",
      "NOT_FOUND": "Dit dienstverband kan niet worden gevonden."
    },
    "CREATE": {
      "TITLE": "Dienstverband toevoegen",
      "ORGANISATION": "Organisatie",
      "SEARCH_ORGANISATION": "Zoek organisatie of KvK-nummer",
      "NO_ORGANISATIONS": "Geen organisaties gevonden.",
      "FUNCTION": "Functie",
      "START_DATE": "Startdatum",
      "END_DATE": "Einddatum",
      "MANAGERIAL_LABEL": "Leidinggevende functie",
      "BUSINESS_REGISTRY_NUMBER": "KvK-nummer",
      "SAVE": "Opslaan",
      "SAVE_SUCCESS": "Dienstverband succesvol toegevoegd.",
      "SAVE_ERROR": "Er is een fout opgetreden bij het toevoegen van het dienstverband.",
      "LOAD_ORGANISATIONS_ERROR": "Er is een fout opgetreden bij het laden van organisaties.",
      "END_DATE_BEFORE_START": "Einddatum mag niet voor de startdatum liggen.",
      "ORGANISATION_UNAVAILABLE": "Deze werkgever is niet meer beschikbaar. Kies een andere.",
      "FUNCTION_UNKNOWN": "Deze functie is niet meer beschikbaar. Kies een andere.",
      "BINDING_CONFLICT": "Deze werkgever kent al iemand met jouw e-mailadres, onder een ander account. Vraag hen om je uit te nodigen.",
      "IDENTITY_INCOMPLETE": "Je account mist je naam of e-mailadres, waardoor een werkgever je nog niet kan registreren. Log in met Yivi om dit te vervolledigen.",
      "REQUEST_ALREADY_PENDING": "Je hebt al een openstaande aanvraag bij deze werkgever. Wacht op hun reactie.",
      "INVITATION_PENDING": "Deze werkgever heeft je al uitgenodigd. Accepteer of weiger die uitnodiging in je dienstverbandoverzicht."
    }
  },
  "TOOLBOXES": {
    "TABS": {
      "LIST": "Toolboxen",
      "REGISTRATION": "Meetings"
    },
    "EMPTY_STATE": "Geen toolboxes beschikbaar",
    "LAST_UPDATED": "Laatst bijgewerkt",
    "VIEW_DOCUMENT": "Document bekijken",
    "ASYNC": {
      "COMPLETED": "Toolbox voltooid",
      "ERROR_COMPLETING": "Toolbox voltooien mislukt"
    },
    "FOLLOWED": {
      "TITLE": "Gevolgde toolboxes",
      "LINK": "Bekijk gevolgde toolboxes",
      "FILTER_CATEGORY": "Categorie",
      "FILTER_TYPE": "Soort",
      "TYPE_SYNCHRONOUS": "Synchroon",
      "TYPE_ASYNCHRONOUS": "Asynchroon",
      "TYPE_MANUAL": "Handmatig",
      "NOT_AVAILABLE": "Niet meer beschikbaar",
      "EMPTY_STATE": "U heeft nog geen toolboxes voltooid",
      "EMPTY_FILTERED": "Geen gevolgde toolboxes komen overeen met deze filters"
    },
    "MEETING": {
      "HOST_MEETING": "Toolboxmeeting organiseren",
      "START_ANOTHER_TITLE": "Nog een meeting starten?",
      "START_ANOTHER_MESSAGE": "Je hebt al {count, plural, =1{één toolboxmeeting} other{# toolboxmeetings}} lopen. Nog een starten?",
      "START_ANOTHER_CONFIRM": "Nog een starten",
      "ONLY_MANAGERIAL_CAN_HOST": "Alleen leidinggevenden kunnen een toolboxmeeting organiseren",
      "ONLY_MANAGERIAL_CAN_MANAGE": "Alleen leidinggevenden kunnen een toolboxmeeting beheren",
      "VIEW_ACTIVE_MEETING": "Bekijk actieve meeting",
      "SELECT_ACTIVE_MEETING": "Kies een meeting",
      "MANUAL": {
        "START_BUTTON": "Handmatige toolboxmeeting aanmaken",
        "DESCRIPTION": "Start een nieuwe handmatige toolboxmeeting voor je team als leidinggevende.",
        "START_TITLE": "Handmatige toolboxmeeting aanmaken",
        "ORGANISATION": "Organisatie",
        "ORGANISATION_PLACEHOLDER": "Kies een organisatie",
        "TITLE": "Titel",
        "TITLE_PLACEHOLDER": "Voer een titel in",
        "DESCRIPTION_PLACEHOLDER": "Optionele beschrijving",
        "START_MISSING_FIELDS": "Vul alle verplichte velden in",
        "TITLE_REQUIRED": "Titel is verplicht",
        "TITLE_NOT_ALLOWED": "Titel kan alleen bij een handmatige toolboxmeeting worden aangepast",
        "END_BEFORE_START": "Eindtijd mag niet voor starttijd liggen",
        "ACTIVE_LIST_TITLE": "Jouw toolboxmeetings",
        "ACTIVE_BADGE": "Bezig",
        "PLANNED_BADGE": "Gepland",
        "CONTINUE_BUTTON": "Verder met deze meeting"
      },
      "TITLE": "Toolboxmeeting",
      "PARTICIPANTS": "Deelnemers",
      "NO_PARTICIPANTS": "Nog geen deelnemers",
      "EXTERNAL_PARTICIPANT": "extern",
      "INFORMATION": "Informatie",
      "START_DATE": "Startdatum",
      "END_DATE": "Einddatum",
      "DESCRIPTION": "Beschrijving",
      "FINISH_MEETING": "Meeting afsluiten",
      "EDIT_MEETING": "Meeting bewerken",
      "SAVE": "Opslaan",
      "CANCEL": "Annuleren",
      "FINISH_CONFIRMATION_TITLE": "Meeting afsluiten?",
      "FINISH_CONFIRMATION_MESSAGE": "Weet u zeker dat u deze toolboxmeeting wilt afsluiten?",
      "MEETING_ENDED_TITLE": "Meeting afgesloten",
      "MEETING_ENDED_MESSAGE": "Deze meeting is afgesloten op {endTime} door {finishedByName}",
      "MEETING_ALREADY_STARTED": "Een meeting is al gestart door iemand anders",
      "ERROR_POLLING_MEETING": "Er is een fout opgetreden bij het controleren op meetings",
      "ERROR_STARTING_MEETING": "Kan meeting niet aanmaken",
      "ERROR_LOADING_MEETING": "Kan meeting niet laden",
      "ERROR_UPDATING_MEETING": "Kan meeting niet bijwerken",
      "ERROR_FINISHING_MEETING": "Kan meeting niet afsluiten",
      "ERROR_END_BEFORE_START": "De eindtijd mag niet vóór de starttijd liggen",
      "SCAN_QR_CODE": "QR-code scannen",
      "RETRY_SCAN": "Opnieuw scannen",
      "SCAN_TO_JOIN": "Scan om deel te nemen",
      "JOIN_TOOLBOX_MEETING": "Deelnemen aan toolbox meeting",
      "JOIN_DESCRIPTION": "Neem deel aan een bestaande toolboxmeeting door een QR-code te scannen of een meetingcode in te voeren.",
      "QR_SCAN_WRONG_MEETING": "Deze QR-code is voor een andere meeting",
      "QR_SCAN_ALREADY_PARTICIPANT": "U bent al deelnemer aan deze meeting",
      "QR_SCAN_INVALID": "Ongeldig QR-code formaat",
      "QR_SCAN_ERROR": "Er is een fout opgetreden bij het scannen",
      "QR_SCAN_NO_PERMISSION": "Cameratoegang is vereist om QR-codes te scannen",
      "SUCCESSFULLY_JOINED": "Succesvol deelgenomen aan de meeting",
      "ADD_PARTICIPANT": {
        "TITLE": "Deelnemer toevoegen",
        "CHOOSE_METHOD": "Kies hoe u een deelnemer aan deze toolbox meeting wilt toevoegen: scan hun i-LOP QR-code of voer handmatig een naam in",
        "SCAN_QR_CODE": "QR-code scannen",
        "MANUAL": "Handmatig",
        "MANUAL_ENTRY": "Handmatige invoer",
        "OR": "of",
        "FIRST_NAME": "Voornaam",
        "LAST_NAME": "Achternaam",
        "FIRST_NAME_PLACEHOLDER": "Voer voornaam in",
        "LAST_NAME_PLACEHOLDER": "Voer achternaam in",
        "CONFIRM": "Bevestigen",
        "ADDING": "Toevoegen...",
        "SUCCESS": "Deelnemer succesvol toegevoegd",
        "ERROR": "Kan deelnemer niet toevoegen",
        "MEETING_NOT_FOUND": "Meeting niet gevonden",
        "ALREADY_PARTICIPANT": "Deze persoon is al een deelnemer aan de meeting",
        "MEETING_INACTIVE": "De meeting is niet actief",
        "QR_VERIFY_PERMISSION_ERROR": "U heeft geen toestemming om deze QR-code te verifiëren. Gebruik in plaats daarvan handmatige invoer.",
        "MISSING_PARAMETERS": "Ontbrekende vereiste parameters voor navigatie",
        "NAVIGATION_ERROR": "Kan niet navigeren naar de pagina voor het toevoegen van deelnemers",
        "PERSON_NOT_IN_ORGANISATION": "De gescande persoon behoort niet tot uw organisatie",
        "PERSON_NOT_BOUND": "Deze persoon heeft nog geen app-account. Voeg diegene toe als externe deelnemer.",
        "PERSON_BINDING_CONFLICT": "Deze persoon is aan meerdere app-accounts gekoppeld en kan niet worden toegevoegd. Neem contact op met uw beheerder.",
        "NO_PERSON_RECORD": "Deze medewerker heeft een app-account, maar is nog niet in dienst bij een organisatie en kan daarom niet als deelnemer worden toegevoegd. Voeg diegene toe als externe deelnemer."
      }
    }
  },
  "SIGNATURE": {
    "TITLE": "Handtekening",
    "INSTRUCTIONS": "Teken hieronder",
    "CLEAR": "Wissen",
    "CONFIRM": "Bevestigen"
  },
  "PERSON_CHECKIN_CARD": {
    "CHECKED_IN_AT": "Ingecheckt op:",
    "LAST_CHECKED_OUT_AT": "Laatst uitgecheckt op:",
    "NOT_CHECKED_IN": "Niet ingecheckt",
    "CERTIFICATES": "Certificaten",
    "MORE_CERTIFICATES": "{count} meer",
    "ADD_CERTIFICATE": "Certificaat toevoegen"
  },
  "ZZP_COMPANY": {
    "TITLE": "Bedrijfsprofiel (ZZP)",
    "INTRO": "Maak een profiel aan voor jouw eenmansbedrijf (ZZP).",
    "COMPANY_NAME": "Bedrijfsnaam",
    "KVK_NUMBER": "KvK-nummer",
    "SAVE": "Opslaan",
    "TOAST": {
      "SAVED": "Bedrijfsprofiel is opgeslagen",
      "ERROR": "Er is een fout opgetreden bij het opslaan van het bedrijfsprofiel",
      "LOAD_ERROR": "Er is een fout opgetreden bij het laden van het bedrijfsprofiel"
    },
    "KVK_EXTRACT": {
      "LABEL": "KvK-uittreksel",
      "ADD": "KvK-uittreksel toevoegen",
      "VIEW": "KvK-uittreksel bekijken",
      "REMOVE": "Verwijderen",
      "UPLOADED": "KvK-uittreksel is geüpload",
      "REMOVED": "KvK-uittreksel is verwijderd",
      "INVALID_TYPE": "Alleen PDF- of afbeeldingsbestanden zijn toegestaan",
      "DOCUMENT_DATE": "Datum op het KvK-uittreksel",
      "VALID_UNTIL": "Geldig tot",
      "OUT_OF_DATE": "Dit KvK-uittreksel is te oud. Upload een recenter uittreksel.",
      "NEEDS_DATE": "Vul de datum op het uittreksel in zodat het meetelt.",
      "NEEDS_DOCUMENT": "Upload het KvK-uittreksel zodat de datum meetelt."
    }
  },
  "START_WORK_INSTRUCTION": {
    "NEW_TITLE": "Nieuwe SWI",
    "STEP_OF": "Stap {step} van {total}",
    "NEXT": "Volgende",
    "LOADING": "Bezig met laden…",
    "SAVED": "Start Werk Instructie opgeslagen",
    "STEP_LABEL": {
      "PERIOD": "Datum of periode",
      "MESSAGES": "Berichten: veiligheidsinstructies van vandaag",
      "INSTRUCTIONS": "Instructies",
      "TOOLBOXES": "Toolboxen",
      "CHECKLISTS": "Checklists",
      "SUMMARY": "Samenvatting",
      "NEW_MESSAGE": "Nieuw bericht"
    },
    "PERIOD": {
      "SINGLE_DAY": "Eén dag",
      "RANGE": "Periode",
      "DATE": "Datum",
      "FROM": "Van",
      "UNTIL_INCLUSIVE": "Tot en met",
      "ONE_PER_DAY_HINT": "Er kan maar één SWI per dag actief zijn op dit project.",
      "TAKEN_DAYS_HINT": "Gemarkeerde dagen hebben al een SWI en kunnen niet worden gekozen.",
      "OVERLAP": "Er loopt al een Start Werk Instructie in deze periode. Kies andere datums."
    },
    "CONTENT": {
      "MESSAGES_HEADING": "Berichten",
      "MESSAGES_HINT": "Alleen berichten van het type Veiligheid worden getoond. Meerdere berichten mogelijk.",
      "MESSAGES_EMPTY": "Geen actuele veiligheidsberichten op dit project.",
      "INSTRUCTIONS_HEADING": "Instructies",
      "INSTRUCTIONS_HINT": "Alleen content met het vinkje \"kan gebruikt worden in SWI\" wordt hier getoond.",
      "INSTRUCTIONS_EMPTY": "Geen instructies beschikbaar voor een SWI.",
      "TOOLBOXES_HEADING": "Toolboxen",
      "TOOLBOXES_HINT": "Alleen content met het vinkje \"kan gebruikt worden in SWI\" wordt hier getoond.",
      "TOOLBOXES_EMPTY": "Geen toolboxen beschikbaar voor een SWI.",
      "CHECKLISTS_HEADING": "Checklists",
      "CHECKLISTS_HINT": "Alleen content met het vinkje \"kan gebruikt worden in SWI\" wordt hier getoond.",
      "CHECKLISTS_EMPTY": "Geen checklists beschikbaar voor een SWI.",
      "MEDIUM_VIDEO": "Video",
      "MEDIUM_DOCUMENT": "Lezen"
    },
    "SUMMARY": {
      "CHANGE": "Wijzig",
      "NOTHING_SELECTED": "Niets gekozen",
      "NO_CONTENT": "Kies minstens één bericht, instructie, toolbox of checklist.",
      "SAVE": "Opslaan",
      "PERIOD_SINGLE": "Start Werk Instructie van {date}",
      "PERIOD_RANGE": "Start Werk Instructie van {from} t/m {to}"
    },
    "REPEAT": {
      "HEADING": "Herhaling",
      "FIRST_ENTRY": "Alleen bij eerste keer betreden bouwplaats",
      "EVERY_ENTRY": "Elke keer bij betreden bouwplaats",
      "AFTER_ABSENCE": "Opnieuw volgen na afwezigheid",
      "ABSENCE_DAYS": "Langer dan (dagen)",
      "ABSENCE_DAYS_RANGE": "Vul een getal tussen {min} en {max} in."
    },
    "EDIT_TITLE": "SWI bewerken",
    "NEW_MESSAGE": {
      "ACTION": "Nieuw bericht (tekst of video)",
      "OR_PICK": "Of kies bestaande berichten",
      "HINT": "De periode en de categorie worden overgenomen van de Start Werk Instructie.",
      "ADD": "Bericht toevoegen",
      "SAVE": "Bericht opslaan",
      "REMOVE": "Bericht verwijderen"
    },
    "FOLLOW": {
      "TITLE": "Start Werk Instructie",
      "INTRO": "Werk alles hieronder af en teken daarna.",
      "PROGRESS": "{done} van {total} afgerond",
      "EMPTY": "Er is vandaag niets te volgen op dit project.",
      "LOAD_FAILED": "De Start Werk Instructie kon niet worden geladen.",
      "RETRY": "Opnieuw proberen",
      "NEXT": "Volgende stap",
      "SIGN_INTRO": "Controleer je gegevens en teken.",
      "NAME": "Naam",
      "DATE": "Datum",
      "COMPANY": "Bedrijf",
      "FUNCTION": "Functie",
      "CLEAR": "Wissen",
      "SIGN_AND_FINISH": "Ondertekenen en afronden",
      "SIGNED": "Start Werk Instructie ondertekend",
      "SIGN_FAILED": "Ondertekenen is niet gelukt. Probeer het opnieuw."
    },
    "CARD": {
      "HEADING": "Actieve Start Werk Instructie",
      "STATUS_ACTIVE": "Actief",
      "STATUS_PLANNED": "Gepland",
      "PERIOD_RANGE": "{from} t/m {to}",
      "REPEAT_EVERY_ENTRY": "elke keer bij betreden",
      "REPEAT_FIRST_ENTRY": "alleen eerste keer bij betreden"
    }
  }
}
